import axiosInstance from "../../service/axiosInstance";
import { API_DOMAIN, POST } from "../../utility/constants";

export interface CopyFieldReference {
  referenceType: 'INELIGIBLE_FIELD' | 'CONDITION';
  sourceIneligibleRuleId?: number;
  sourceIneligibleRuleConditionId?: number;
  location: string;
  fieldName: string;
}

export interface CopyableIneligibleSetting {
  ineligibleSettingId: number;
  code: string;
  description: string;
  altDescription?: string;
  order: number;
  criteriaCount: number;
  ineligibleField?: string;
  existsOnTarget: boolean;
  invalidFieldReferences: CopyFieldReference[];
}

export interface CopyARIneligibleSettingsPreviewResponse {
  sourceArCollateralId: number;
  targetArCollateralId: number;
  settings: CopyableIneligibleSetting[];
}

export interface CopyInvIneligibleSettingsPreviewResponse {
  sourceInvCollateralId: number;
  targetInvCollateralId: number;
  settings: CopyableIneligibleSetting[];
}

export interface CopyFieldResolution {
  action: 'MAP' | 'REMOVE';
  sourceIneligibleRuleId?: number;
  sourceIneligibleRuleConditionId?: number;
  mappedField?: string;
}

export interface CopyARIneligibleSettingsResult {
  copiedIneligibleSettingIds: number[];
  copiedCount: number;
  skippedSettingCodes: string[];
}

export interface CopyInvIneligibleSettingsResult {
  copiedIneligibleSettingIds: number[];
  copiedCount: number;
  skippedSettingCodes: string[];
}

export const previewCopyARIneligibleSettings = async (
  borrowerId: number,
  sourceArCollateralId: number,
  targetArCollateralId: number,
) => {
  const response = await axiosInstance.request({
    url: `${API_DOMAIN}/ineligibleSetting/copy/preview`,
    method: POST,
    data: {
      borrowerId,
      sourceArCollateralId,
      targetArCollateralId,
    },
  });

  return response.data as CopyARIneligibleSettingsPreviewResponse;
};

export const copyARIneligibleSettings = async (
  borrowerId: number,
  sourceArCollateralId: number,
  targetArCollateralId: number,
  selectedIneligibleSettingIds: number[],
  conflictResolution: 'REPLACE' | 'SKIP',
  fieldResolutions: CopyFieldResolution[],
) => {
  const response = await axiosInstance.request({
    url: `${API_DOMAIN}/ineligibleSetting/copy/`,
    method: POST,
    data: {
      borrowerId,
      sourceArCollateralId,
      targetArCollateralId,
      selectedIneligibleSettingIds,
      conflictResolution,
      fieldResolutions,
    },
  });

  return response.data as CopyARIneligibleSettingsResult;
};


export const previewCopyInventoryIneligibleSettings = async (
  borrowerId: number,
  sourceInvCollateralId: number,
  targetInvCollateralId: number,
) => {
  const response = await axiosInstance.request({
    url: `${API_DOMAIN}/inv/ineligibleSetting/copy/preview`,
    method: POST,
    data: {
      borrowerId,
      sourceInvCollateralId,
      targetInvCollateralId,
    },
  });

  return response.data as CopyInvIneligibleSettingsPreviewResponse;
};

export const copyInventoryIneligibleSettings = async (
  borrowerId: number,
  sourceInvCollateralId: number,
  targetInvCollateralId: number,
  selectedIneligibleSettingIds: number[],
  conflictResolution: 'REPLACE' | 'SKIP',
  fieldResolutions: CopyFieldResolution[],
) => {
  const response = await axiosInstance.request({
    url: `${API_DOMAIN}/inv/ineligibleSetting/copy/`,
    method: POST,
    data: {
      borrowerId,
      sourceInvCollateralId,
      targetInvCollateralId,
      selectedIneligibleSettingIds,
      conflictResolution,
      fieldResolutions,
    },
  });

  return response.data as CopyInvIneligibleSettingsResult;
};